import angular from 'angular';

export const SHARED_MODULE = 'app.shared';

angular.module(SHARED_MODULE, []);

export default SHARED_MODULE;
